// External libraries
import styled from '@emotion/styled';

// Internal modules
import { HEADER_COLOR } from '@/styles';

const SectionHeading = styled.h2`
  color: ${HEADER_COLOR};
  font-size: calc(1em * (14 / 16));
  font-weight: 600;
  line-height: 1.33;
  margin-bottom: 12px;

  @media (min-width: 365px) {
    font-size: calc(1em * (15 / 16));
  }
`;

const SectionHeadingLarge = styled.h2`
  color: ${HEADER_COLOR};
  font-size: 24px;
  font-weight: 300;
  line-height: 1.5;
  margin-bottom: 9px;
`;

const SectionSubHeading = styled.h3`
  color: #71777c;
  font-size: 15px;
  font-weight: normal;
  line-height: 1.4;
  margin-bottom: 18px;
`;

export { SectionHeading, SectionHeadingLarge, SectionSubHeading };
